import { useRef } from 'react';
const safeDocument = typeof document !== 'undefined' ? document : {};

export default () => {
  const hiddenGladly = useRef();
  const { body } = safeDocument;

  const hideGladly = async () => {
    if (!body || !body.classList || hiddenGladly.current) return;
    body.classList.add('gladly-hidden');
    hiddenGladly.current = true;
  };

  const showGladly = () => {
    if (!body || !body.classList || !hiddenGladly.current) return;
    body.classList.remove('gladly-hidden');
    hiddenGladly.current = false;
  };

  return [hideGladly, showGladly];
};
